let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("bUMj8")).then(() => parcelRequire('7EWLy'));